'use client';

import { useCallback, useEffect, useRef } from 'react';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import { IncidentsStreamingEvents, MessageHandler } from '../service/IncidentsStreamingEvents';

type Options = {
  enabled?: boolean;
};

export const useIncidentsStreaming = (options?: Options) => {
  const { enabled } = options ?? {};
  const { orgId } = useCurrentUser();
  const streamRef = useRef(orgId ? IncidentsStreamingEvents.getInstance(orgId) : null);

  useEffect(() => {
    if (!enabled) return;

    if (!streamRef.current && orgId) {
      streamRef.current = IncidentsStreamingEvents.getInstance(orgId);
    }

    return () => {
      streamRef.current?.destroy();
      streamRef.current = null;
    };
  }, [streamRef, orgId, enabled]);

  const subscribe = useCallback((handler: MessageHandler) => {
    if (!streamRef.current || !enabled) {
      return () => null;
    }

    streamRef.current.init();
    const dispose = streamRef.current.onMessage(handler);

    return () => {
      dispose();
    };
  }, []);

  return { subscribe };
};
